import React, { useReducer, useContext } from 'react'
import PropTypes from 'prop-types'
import NotificationsContext from '../Notifications/Context'
import Context from './Context'
import getActions from './Actions'
import getSelectors from './Selectors'
import { reducer, initialState } from './Reducer'

const DevicesProvider = ({ children }) => {
  const { actions: toast } = useContext(NotificationsContext)
  const [state, dispatch] = useReducer(reducer, initialState)
  const actions = getActions(state, dispatch, toast)
  const selectors = getSelectors(state)

  return (
    <Context.Provider value={{
      state,
      actions,
      selectors,
      dispatch
    }}
    >
      {children}
    </Context.Provider>
  )
}

DevicesProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default DevicesProvider
